export default "__VITE_ASSET__BV$3_P3p__"